import React from "react";
import PropTypes from "prop-types";
import topic from "pubsub-js";

import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Fab from "@mui/material/Fab";
import DebugIcon from "@mui/icons-material/BugReport";
import CloseIcon from "@mui/icons-material/Clear";
import StopIcon from "@mui/icons-material/Stop";
import RecordIcon from "@mui/icons-material/FiberManualRecord";
import DownloadIcon from "@mui/icons-material/CloudDownload";
import SettingsIcon from "@mui/icons-material/Settings";


import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import LogOptions from "./LogOptions";

import FileSaver from "file-saver";
import { moment } from "@mm/timespan";

import withStyles from '@mui/styles/withStyles';

const styles = withStyles((theme) => ({
    buttonRoot: {
        position: "fixed",
        right: 5,
        bottom: 5,
        backgroundColor: "transparent",
        zIndex: theme.zIndex.modal - 50
    },
    controls: {
        position: "absolute",
        right: 15,
        width: 60,
        top: 0,
        bottom: 15,
        backgroundColor: "white",
        textAlign: "right"
    },
    controlButton: {
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    root: {
        position: "fixed",
        height: 220,
        left: 5, 
        right: 15,
        bottom: 15,
        zIndex: theme.zIndex.modal - 50
    },
    content: {
        margin: "10px 70px 10px 10px"
    },
    scrollWrapper: {
        height: "100%",
        width: "100%",
        overflowY: "scroll"
    }
}));

class DebugDisplay extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: "",
            visible: false,
            record: true,
            showDownload: false,
            showSettingsDialog: false
        };
        this._contentElement = React.createRef();
    }

    componentDidMount() {
        this.registerTopic();
    }

    componentWillUnMount( ) {
        this.unregisterTopic();
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    registerTopic() {
        const {
            topicname
        } = this.props;
        console.log("Subscribe addContent to", topicname);
        this._handle = topic.subscribe(topicname, this.addContent);
    }

    unregisterTopic() {
        console.log("Unsubscribin....");
        topic.unsubscribe(this._handle);
    }

    _download = () => {
        const fn = moment(new Date()).strftime("%Y%m%d%H%M%S_logs.jsontxt");
        const blob = new Blob([ this.state.content ]);
        this.setState({ showDownload: false });
        FileSaver.saveAs(blob, fn);
    }

    scrollToBottom() {
        try {
            const scrollHeight = this._contentElement.current.scrollHeight;
            const height = this._contentElement.current.clientHeight;
            const maxScrollTop = scrollHeight - height;
            this._contentElement.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        } catch(err) {
            // Silently fail
        }
    }


    addContent = (topic, rec) => {
        const {
            record,
            content
        } = this.state;
        if (record) {
            const newcontent = content.concat("\r\n").concat(JSON.stringify(rec));
            this.setState({ content: newcontent });
        }
    };

    render() {
        const {
            classes,
            maxChars
        } = this.props;
        const {
            visible,
            content,
            record,
            showDownload,
            showSettingsDialog
        } = this.state;

        if (visible) {
            return (<>
                <Paper className={ classes.root}>
                    <div className={ classes.controls}>
                        <IconButton
                            className={ classes.controlButton }
                            label="Schließe Log"
                            aria-label="Close Log"
                            onClick={ () => {
                                this.setState({ "visible": false}); 
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        { record ?
                            <Fab color="extended"
                                className={ classes.controlButton }
                                label="Beende Aufzeichnung"
                                aria-label="Beende Aufzeichnung"
                                size="small"
                                onClick={ () => {
                                    this.setState({ "record": false}); 
                                }}
                            >
                                <StopIcon/>
                            </Fab>
                            :
                            <Fab color="extended"
                                className={ classes.controlButton }
                                label="Starte Aufzeichnung"
                                aria-label="Starte Aufzeichnung"
                                size="small"
                                onClick={ () => {
                                    this.setState({ "record": true}); 
                                }}
                            >
                                <RecordIcon />
                            </Fab>
                        }
                        <Fab color="extended"
                            className={ classes.controlButton }
                            label="Log herunterladen"
                            aria-label="Log herunterladen"
                            size="small"
                            onClick={ () => {
                                this.setState({ showDownload: true });
                            }}
                        >
                            <DownloadIcon />
                        </Fab>
                        <Fab color="extended"
                            className={ classes.controlButton }
                            label="Einstellungen"
                            aria-label="Einstellungen"
                            size="small"
                            onClick={ () => {
                                this.setState({ showSettingsDialog: true });
                            }}
                        >
                            <SettingsIcon />
                        </Fab>
                    </div>
                    <div className={ classes.scrollWrapper } 
                        ref={ this._contentElement } 
                    >
                        <pre className={ classes.content }>
                            { content.substr(-maxChars) }
                        </pre>
                    </div>
                </Paper>
                <Dialog 
                    onClose={ () => { 
                        this.setState({ showSettingsDialog: false }); 
                    } } 
                    aria-labelledby="settings-dialog-title" 
                    open={showSettingsDialog}
                >
                    <DialogTitle id="Settings-dialog-title">
                        Einstellungen
                    </DialogTitle>
                    <DialogContent>
                        <LogOptions />
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            onClick={ () => {
                                this.setState({ showSettingsDialog: false });
                            }} 
                            color="primary"
                        >
                            Schließen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog 
                    onClose={ () => { 
                        this.setState({ showDownload: false }); 
                    } } 
                    aria-labelledby="download-dialog-title" 
                    open={showDownload}
                >
                    <DialogTitle id="download-dialog-title">
                        Log-Dateien speichern...
                    </DialogTitle>
                    <DialogContent>
                        <p>
                            Die gespeicherten Log-Dateien können unter Umständen
                            sensible und unverschlüsselte personenbezogene
                            Daten enthalten. Bitte speichern Sie diese an einem
                            sicheren Ort und geben
                            Sie auschließlich an vertrauenswürdige und befugte
                            Personen weiter.  
                        </p>
                        <p>
                            Mit dem Download erklären Sie, dass Sie die
                            Verantwortung für die Sicherheit und den Schutz der
                            Daten gemäß den an Ihrer Schule/Institution
                            geltenden Verfahrensregeln übernehmen.
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            onClick={ () => {
                                this.setState({ showDownload: false });
                            }} 
                            color="primary"
                        >
                            Nein
                        </Button>
                        <Button 
                            onClick={ this._download } 
                            color="primary" 
                            autoFocus
                        >
                            Einverstanden 
                        </Button>
                    </DialogActions>
                </Dialog>
            </>);
        } else {
            return (
                <div className={ classes.buttonRoot}>
                    <Fab 
                        aria-label="Show Log" 
                        color="extended" 
                        onClick={ () => {
                            this.setState({ "visible": true}); 
                        }}
                    >
                        <DebugIcon />
                    </Fab>
                </div>
            );
        }
    }
}

DebugDisplay.propTypes = {
    topicname: PropTypes.string,
    maxChars: PropTypes.number,
    classes: PropTypes.object.isRequired
};

DebugDisplay.defaultProps = {
    topicname: "frontend/debuglog",
    maxChars: 20000
};

export default styles(DebugDisplay);

